export const availableKeyProducts = (responseList, currentList) => {
  return !currentList || currentList.length === 0
    ? responseList
    : responseList.filter(item => !currentList.find(a => a.id === item.id));
};
